<div *ngIf="organization" class="org-settings">
	<nb-route-tabset [tabs]="tabs" fullWidth></nb-route-tabset>
</div>
